module.exports = __webpack_public_path__ + "static/media/peter.507757e4.png";